import http from '@/uteis/http'

export default class NumeroProcessoService {
  async buscarNumeroProcesso () {
    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/numeroProcessoApi/numeroProcesso').then((response) => {
        let result
        if (response.data) {
          result = response.data.data[0]
        }

        return resolve(result)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get('/d0593/pae-back/v1/numeroProcessoApi/numeroProcesso').then((response) => {
          let result
          if (response.data) {
            result = response.data.data[0]
          }

          return resolve(result)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async buscarNumeroProcessoFiltro (filtro) {
    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/protocolos/numero', { params: filtro }).then((response) => {
        let result
        if (response.data) {
          result = response.data.data[0]
        }

        return resolve(result)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get('/d0593/pae-back/v1/protocolos/numero', { params: filtro }).then((response) => {
          let result
          if (response.data) {
            result = response.data.data[0]
          }

          return resolve(result)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async criarNumeroProcesso (idOrgao, tipoProtocolo) {
    return new Promise((resolve, reject) => {
      http.post('/d0593/pae-back/v1/protocolos/numero', { idOrgao, tipoProtocolo }).then((response) => {
        let result
        if (response.data) {
          result = response.data.data[0]
        }

        return resolve(result)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.post('/d0593/pae-back/v1/protocolos/numero', { idOrgao, tipoProtocolo }).then((response) => {
          let result
          if (response.data) {
            result = response.data.data[0]
          }

          return resolve(result)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }
}
